<script setup>
defineProps({
  size: { type: String, default: 'md' }, // sm, md, lg
});
</script>

<template>
  <svg
    :class="['animate-spin text-primary-600', {
      'h-4 w-4': size === 'sm',
      'h-6 w-6': size === 'md',
      'h-10 w-10': size === 'lg',
    }]"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
  >
    <circle
      class="opacity-25"
      cx="12"
      cy="12"
      r="10"
      stroke="currentColor"
      stroke-width="4"
    />
    <path
      class="opacity-75"
      fill="currentColor"
      d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
    />
  </svg>
</template>
